import {Controller} from "@hotwired/stimulus";

export default class extends Controller {

    static targets = ['container', 'addButton'];
    static values = {
        index: String,
        listUuid: String,
        uiId: String,
        propertyType: String
    };

    connect() {
    }

    addFilter() {
        event.preventDefault();
        let index = this.containerTarget.children.length
        let type = this.propertyTypeValue

        if (index == undefined) {
            index = 0;
        }

        fetch(
            `/lists/${this.listUuidValue}/contacts/add_filter?index=${index}&ui_id=${this.uiIdValue}&type=${type}`,
            {
                method: 'POST',
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
                        .content,
                    Accept: "text/vnd.turbo-stream.html",
                }
            }
        )
            .then((response) => response.text())
            .then((html) => Turbo.renderStreamMessage(html));
    }

    removeFilter(event) {
        event.preventDefault();

        let index = this.indexValue

        fetch(
            `/lists/${this.listUuidValue}/contacts/remove_filter?index=${index}&type${this.typeValue}`,
            {
                method: 'DELETE',
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
                        .content,
                    Accept: "text/vnd.turbo-stream.html",
                }
            }
        )
            .then((response) => response.text())
            .then((html) => Turbo.renderStreamMessage(html));
    }
}